import React from 'react'
import { UserIcon, VideoIcon, CalendarIcon, ThumbUpIcon, DotsVerticalIcon, ArrowRightIcon} from '../../assets/UI/multiple-icons'
import GreetingImg from '../../assets/hello.svg'; 
import './dashboard.css'

export default function Dashboard() {
  return (
    <div className="dashboard">
      <main>
      <div className="main__container">
      <div className="main__title">
                    <img src={GreetingImg} alt="Greeting" />
                    <div className="main__greeting">
                    <h1>Hi <span>Admin</span></h1>
                    <p>Welcome to your admin dashboard</p>
                    </div>
                </div>
                <div className="main__cards">
                    <div className="card">
                        <i className="subscriber"><UserIcon width={54} /></i>
                        <div className="card_inner">
                            <p className="text-primary-p">Number of Employees</p>
                            <span className="font-bold text-title">3578</span>
                        </div>
                    </div>
                    <div className="card">
                        <i className="times"><CalendarIcon width={54} /></i>
                        <div className="card_inner">
                            <p className="text-primary-p">Number of Clients</p>
                            <span className="font-bold text-title">2467</span>
                        </div>
                    </div>
                    <div className="card">
                        <i className="video"><VideoIcon width={54} /></i>
                        <div className="card_inner">
                            <p className="text-primary-p">Number of Projects</p>
                            <span className="font-bold text-title">340</span>
                        </div>
                    </div>
                    <div className="card">
                        <i className="thumbup"><ThumbUpIcon width={54} /></i>
                        <div className="card_inner">
                            <p className="text-primary-p">Number of Invoices</p>
                            <span className="font-bold text-title">645</span>
                        </div>
                    </div>
                    </div>
        </div>
      </main>
    </div>
  )
}
